import { render, staticRenderFns } from "./CompleteSocialProfile.vue?vue&type=template&id=bb522e7a&scoped=true&"
import script from "./CompleteSocialProfile.vue?vue&type=script&lang=js&"
export * from "./CompleteSocialProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompleteSocialProfile.vue?vue&type=style&index=0&id=bb522e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb522e7a",
  null
  
)

export default component.exports